import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useFetch } from "../lib/useData";
import { PageHero, Section } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1633368516165-f7b04d6428d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function FAQ() {
  const { data: faqs } = useFetch("/public/faqs");
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  const filtered = (faqs || []).filter((f) => f.question.toLowerCase().includes(q.toLowerCase()) || f.answer.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHero title="Frequently Asked Questions" subtitle="Answers to common questions" image={HERO} />
      <Section className="max-w-3xl">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search questions…" className="w-full rounded-full border border-amber-300 px-5 py-3 mb-8 focus:outline-none focus:ring-2 focus:ring-orange-400" data-testid="faq-search" />
        <div className="space-y-3" data-testid="faq-list">
          {filtered.map((f) => (
            <div key={f.id} className="bg-white border border-amber-200 rounded-2xl overflow-hidden">
              <button onClick={() => setOpen(open === f.id ? null : f.id)} className="w-full flex items-center justify-between text-left px-5 py-4" data-testid={`faq-q-${f.id}`}>
                <span className="font-semibold text-stone-900">{f.question}</span>
                <ChevronDown className={`w-5 h-5 text-orange-600 transition-transform ${open === f.id ? "rotate-180" : ""}`} />
              </button>
              {open === f.id && <div className="px-5 pb-5 text-stone-600" data-testid={`faq-a-${f.id}`}>{f.answer}</div>}
            </div>
          ))}
          {filtered.length === 0 && <p className="text-stone-500 text-center py-8">No questions match your search.</p>}
        </div>
      </Section>
    </div>
  );
}
